import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../firebase/config';
import { Listing } from '../types';

export const seedListings = async (userId: string) => {
  const sampleListings: Omit<Listing, 'id'>[] = [
    {
      userId,
      address: '123 Main Street',
      city: 'San Francisco',
      state: 'CA',
      zipCode: '94102',
      status: 'pending',
      createdAt: new Date(),
      updatedAt: new Date()
    },
    {
      userId,
      address: '456 Oak Avenue',
      city: 'Los Angeles',
      state: 'CA',
      zipCode: '90012',
      status: 'pending',
      createdAt: new Date(),
      updatedAt: new Date()
    },
    {
      userId,
      address: '789 Pine Boulevard',
      city: 'San Diego',
      state: 'CA',
      zipCode: '92101',
      status: 'pending',
      createdAt: new Date(),
      updatedAt: new Date()
    },
    {
      userId,
      address: '321 Elm Court',
      city: 'Sacramento',
      state: 'CA',
      zipCode: '95814',
      status: 'pending',
      createdAt: new Date(),
      updatedAt: new Date()
    },
    {
      userId,
      address: '654 Maple Drive',
      city: 'San Jose',
      state: 'CA',
      zipCode: '95113',
      status: 'pending',
      createdAt: new Date(),
      updatedAt: new Date()
    }
  ];
  try {
    console.log('Starting to seed listings...');
    
    const listingsRef = collection(db, 'listings');
    
    for (const listing of sampleListings) {
      const docRef = await addDoc(listingsRef, {
        ...listing,
        createdAt: Timestamp.fromDate(listing.createdAt!),
        updatedAt: Timestamp.fromDate(listing.updatedAt!)
      });
      console.log(`Added listing: ${listing.address} with ID: ${docRef.id}`);
    }
    
    console.log('Successfully seeded all listings!');
  } catch (error) {
    console.error('Error seeding listings:', error);
    throw error;
  }
};

// Uncomment below to run this script directly
// seedListings();
